import api from "../api/flexapi";

export const libraryCatalogueLoadBegin = "LIBRARY_CATALOGUE_LOAD_BEGIN";
export const libraryCatalogueLoadSuccess = "LIBRARY_CATALOGUE_LOAD_SUCCESS";
export const libraryCatalogueLoadFailed = "LIBRARY_CATALOGUE_LOAD_FAILED";

export const LIBRARY_SET_PAGE_PARAMETERS = "LIBRARY_SET_PAGE_PARAMETERS";
export const LIBRARY_RESET_PAGE_PARAMETERS = "LIBRARY_RESET_PAGE_PARAMETERS";

export const setLibraryPageParameters = payload => ({
  type: LIBRARY_SET_PAGE_PARAMETERS,
  payload,
});

export const resetLibraryPageParameters = () => ({
  type: LIBRARY_RESET_PAGE_PARAMETERS,
});

export function loadLibraryCatalogueItems(filters) {
  return dispatch => {
    dispatch({ type: libraryCatalogueLoadBegin, payload: null });

    return api
      .getLibraryCatalogItems(filters)
      .then(response => {
        dispatch({ type: libraryCatalogueLoadSuccess, payload: response.body });
      })
      .catch(err => {
        dispatch({
          type: libraryCatalogueLoadFailed,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

export function submitCatalogueFilters(filters, dispatch, props) {
  dispatch({ type: libraryCatalogueLoadBegin, payload: null });

  return api
    .getLibraryCatalogItems(filters)
    .then(response => {
      dispatch({ type: libraryCatalogueLoadSuccess, payload: response.body });
    })
    .catch(err => {
      dispatch({
        type: libraryCatalogueLoadFailed,
        payload: err.response ? err.response.body : err,
      });
    });
}

// Type of action being performed
export const libraryItemLoadBegin = "LIBRARY_ITEM_LOAD_BEGIN";
export const libraryItemLoadSuccess = "LIBRARY_ITEM_LOAD_SUCCESS";
export const libraryItemLoadFailed = "LIBRARY_ITEM_LOAD_FAILED";

// Call API to load module data
export function loadLibraryItem(itemKey) {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: libraryItemLoadBegin, payload: { itemKey } });

    api
      .getLibraryItem(itemKey)
      .then(response => {
        dispatch({ type: libraryItemLoadSuccess, payload: response.body });
      })
      .catch(err => {
        dispatch({
          type: libraryItemLoadFailed,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./actions/libraryCatalogueActions.jsx